// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","663":"component---src-pages-tattoos-tsx"}[chunkId] + "-" + {"245":"e1c863aacc87802688dc","453":"dfb72b2c6be2688acc7a","663":"94d37813b58b8a6a4a61"}[chunkId] + ".js";
};